export const formatDateWithoutSeconds = (date) => {
    return new Date(date).toLocaleString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
        month: 'short',
        weekday: 'long',
        day: 'numeric',
        year: 'numeric',
    });
};